import { render, staticRenderFns } from "./JobDetailsTalentFindNew.vue?vue&type=template&id=7c16f861&scoped=true"
import script from "./JobDetailsTalentFindNew.vue?vue&type=script&lang=js"
export * from "./JobDetailsTalentFindNew.vue?vue&type=script&lang=js"
import style0 from "./JobDetailsTalentFindNew.vue?vue&type=style&index=0&id=7c16f861&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c16f861",
  null
  
)

export default component.exports